import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { AppProvider } from './context/AppContext';
import { BrowserRouter } from 'react-router-dom';
import PullToRefresh from './Components/PullToRefresh';
import TableInfoSync from './Components/TableInfoSync';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AppProvider>
      <BrowserRouter>
        {/* On every screen, including the welcome, error and QR pages. */}
        <PullToRefresh />
        <TableInfoSync />
        <App />
      </BrowserRouter>
    </AppProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
